import {isOddEven, pfType999, pfType999Color} from "../../constants/general";
import ResultContentList from "./ResultContentList";
import React from "react";
import {withTranslation} from "react-i18next";
import {useLotto5} from "../../store/lotto5/Lotto5Context";

const ResultContentTable = () => {
    const {platform, allNumbersDrawing, lastResult, platformType, t} = useLotto5();

    const {
        result,
        underOverCode,
        oddEvenCode,
        number,
        drawLabel
    } = lastResult;

    return <div className="col-6 no-padding-div pad-r">
        <div className="lotto5-dispaly-result">

            <div className={"lotto5-total lotto5-header-" + platform + " " + pfType999Color}>

                {
                    platform === "KPW" ? <div className="lotto5-row padding-h">
                        <label
                            className="label-title KPW-title">{drawLabel}</label>
                        <p className="total-result" id="total_result"
                        >{result}</p>
                    </div> : <div className="row align-items-lg-end">
                        {(platform !== "888" && !pfType999) && <img className="col-6 no-padding-div"
                                                                    src={require("../../assets/images/banner/banner_lotto5.svg")}
                                                                    alt="///"/>}
                        {result &&
                            <div
                                className={`no-padding-div ${(platform !== "888" && !pfType999) ? "col-6" : "col d-flex align-items-center justify-content-center"}`}>
                                <div className="col-6 p-0">
                                    {platform === "888" &&
                                        <img src={require("../../assets/images/banner/lottery5_banner.png")}
                                             alt=""
                                             className="img-lotto5"/>}
                                    {pfType999 &&
                                        <img
                                            src={require(`../../assets/images/banner/lottery5_banner_${platformType}.png`)}
                                            alt=""
                                            className="img-lotto5"/>}
                                </div>
                                <div className="col-6 p-0 d-flex justify-content-between align-items-center">
                                    <label className="label-title ml-2">{drawLabel}</label>
                                    {
                                        isOddEven ? <p className="total-result mr-2" id="total_result"
                                            >{t("labels:betPrefix." + underOverCode) + "  |   " + t("labels:betPrefix." + oddEvenCode) + "  |   " + t("labels:betPrefix." + number) + "   |   " + result}</p>
                                            : <p className="total-result mr-2" id="total_result"
                                            >{t("labels:betPrefix." + underOverCode) + "  |   " + t("labels:betPrefix." + number) + "   |   " + result}</p>
                                    }
                                </div>

                            </div>}

                    </div>
                }

            </div>

            <div className="lotto5-content-result">
                <table
                    id="keno_result_post"
                    border="1"
                    cellPadding="0"
                    cellSpacing="0"
                    width="100%"
                >
                    <tbody>
                    <ResultContentList
                        allNumbersDrawing={allNumbersDrawing}/>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
}
export default withTranslation()(ResultContentTable);